<template>
  <v-combobox
    v-model="itemName"
    :search-input.sync="searchItem"
    :items="itemOptions"
    item-text="name"
    item-value="name"
    :label="$t('components.items.itemSuggester.productName')"
    :hint="$t('components.items.itemSuggester.required')"
    :rules="rules"
    @input.native="loadItems($event, $data, $props)"
    @keyup.enter.native="addItem(searchItem)"
    persistent-hint
    color="primary"
    autocomplete="off"
    required
    no-filter
  >
    <template v-slot:item="{ index, item }">
      <v-list-item v-on:click="selectTemplate(item)">
        <span v-if="item.vendor">{{ item.vendor.name }} - {{ item.name }}</span>
        <span v-else>{{ item.name }}</span>
        <v-spacer></v-spacer>
        <v-chip outlined class="flex-ml-auto" v-if="item.is_public"
          ><v-icon class="mr-2">mdi-account-multiple</v-icon
          >{{ $t("components.items.itemSuggester.public") }}</v-chip
        >
      </v-list-item>
    </template>
  </v-combobox>
</template>

<script>
import debounce from "@/plugins/debounce";
import api from "@/utils/api";

export default {
  name: "ItemSuggester",
  props: ["name", "disableSuggestions", "rules"],
  data: () => ({
    itemToAddUUID: null,
    itemOptions: [],
    searchItem: "",
  }),
  created() {
    this.loadItems(null, this);
  },
  computed: {
    itemName: {
      get: function () {
        return this.name;
      },
      set: function (value) {
        if (typeof value !== "undefined" && value)
          this.$emit("update:name", value);
      },
    },
  },
  methods: {
    selectTemplate: function (item) {
      this.$emit("update:item", item);
    },
    loadItems: debounce((event, self, props) => {
      self.searchItem = self.searchItem ? self.searchItem : "";
      api
        .getItemList({ search: self.searchItem, include_public: true })
        .then((resp) => {
          self.itemOptions = resp.data.results;
        });
    }, 300),
    addItem: function (val) {
      api.itemsAutocomplete(val).then((resp) => {
        var improvidedUUID = this.itemOptions.length;
        if (resp.data.count === 0) {
          this.itemOptions.push({
            uuid: improvidedUUID,
            name: val,
          });
          this.itemName = val;
        }
      });
    },
  },
};
</script>

<style scoped></style>
